export const FLOATING_BOTTOM_AREA_ID = 'floating-bottom-area'
